import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaImagePickerComponent} from './la-image-picker.component';
import {LaIconModule, LaTextModule} from '..';

@NgModule({
  imports: [
    CommonModule,
    LaIconModule,
    LaTextModule
  ],
  declarations: [LaImagePickerComponent],
  exports: [LaImagePickerComponent]
})
export class LaImagePickerModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaImagePickerModule,
      providers: []
    };
  }
}
